/* global axios */
import ApiClient from './ApiClient';

class PerformanceAPI extends ApiClient {
  constructor() {
    super('performance', { accountScoped: true });
  }

  overview(params = {}) {
    return axios.get(`${this.url}/overview`, { params });
  }

  responseWindows(params = {}) {
    return axios.get(`${this.url}/response_windows`, { params });
  }

  report(params = {}) {
    return axios.get(`${this.url}/report`, { params });
  }

  drilldown(params = {}) {
    return axios.get(`${this.url}/drilldown`, { params });
  }

  export(params = {}) {
    return axios.get(`${this.url}/export`, { params, responseType: 'blob' });
  }

  settings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(performanceSettings) {
    return axios.patch(`${this.url}/settings`, {
      performance_settings: performanceSettings,
    });
  }

  recalculate(params) {
    return axios.post(`${this.url}/recalculate`, params);
  }
}

export default new PerformanceAPI();
